import $ from 'jquery'
import { Modal } from 'bootstrap'

const MOB_MENU_OPEN = 'mob-menu-open'
const EXPANDED_CLASS = 'expanded'

class HeaderDevices {
  constructor(element) {
    if (!element) {
      return false
    }

    this.element = element
    this.wrap = jQuery(element)
    this.burgerBtn = $('.header__burger a', this.element)
    this.menuLink = $('.header__devices__links__title', this.element)
    this.infoModal = new Modal(document.getElementById('loginModal'))

    this.iniMobMenu()
    this.iniHasSubmenu()

    this.iniElements()
    this.iniExpandableText()

    this.openModal()
    this.closeModal()   
  }

  iniMobMenu() {
    this.burgerBtn.on('click', (e) => {
      e.preventDefault()

      if ($('body').hasClass(MOB_MENU_OPEN)) {
        this.hideMenu()
      } else {
        this.showMenu()
      }
    })

    // jQuery(window).on('resize', (_) => {
    //   if ($(window).width > 1278) {
    //     this.hideMenu()
    //   }
    // })
  }

  showMenu() {
    $('html, body').addClass('scrollDisabled')
    $('body').addClass(MOB_MENU_OPEN)
  }

  hideMenu() {
    $('html, body').removeClass('scrollDisabled')
    $('body').removeClass(MOB_MENU_OPEN)
    this.wrap
      .find('.header__devices__links > nav > ul > .header__devices__item')
      .removeClass(EXPANDED_CLASS)
    this.wrap
      .find(
        '.header__devices__links > nav > ul > li > .header__devices__toggleMenu'
      )
      .slideUp()
  }

  iniHasSubmenu() {
    this.menuLink.each(function () {
      var siblings = $(this).siblings().length

      if (siblings) {
        $(this).addClass('has-submenu')
      }
    })
  }

  openModal() {
    this.wrap.find('.header__devices__login button').on('click', () => {
      this.infoModal.show()
    })
  }

  closeModal() {
    this.wrap.find('.modal-dialog .close').on('click', ()=> {
      console.log('close')
      this.infoModal.hide()
    })
  }

  iniElements() {
    this.textItems = this.element.querySelectorAll(
      '.header__devices__links > nav > ul > .header__devices__item'
    )
  }

  iniExpandableText() {
    this.textItems.forEach((i) => {
      i.addEventListener('click', (e) => {
        if (window.innerWidth <= 1278) {
          const $item = $(e.currentTarget)

          if ($item.hasClass(EXPANDED_CLASS)) {
            this.collapseText($item)
          } else {
            this.expandText($item)
          }
        }
      })
    })
  }

  collapseText(target) {
    target.find('.header__devices__toggleMenu').slideUp()
    target.removeClass(EXPANDED_CLASS)
  }

  expandText(target) {
    const self = this

    $(this.textItems)
      .not(target)
      .each(function () {
        self.collapseText($(this))
      })

    target.addClass(EXPANDED_CLASS)
    target.find('.header__devices__toggleMenu').slideDown()
  }
}
export default HeaderDevices
